import { render, staticRenderFns } from "./CompanyMenu.vue?vue&type=template&id=3988ab49"
import script from "./CompanyMenu.vue?vue&type=script&lang=js"
export * from "./CompanyMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports